import React from 'react';
import { TableToggleCommonProps } from 'react-table';

export const GridCheckbox = (props: TableToggleCommonProps) => {
  return (
    <input type="checkbox" checked={props.checked} onClick={(e) => e.stopPropagation()} onChange={props.onChange} />
  );
};
